import { useRef } from 'react';

export const useConnect = () => {
  const anchorRef = useRef<HTMLButtonElement>(null);

  return {
    anchorRef,
  };
};
